import { useEffect } from 'react';

import { toastr } from 'react-redux-toastr';
import { useParams } from 'react-router-dom';
import { setPreparationCentre } from 'store/country/countrySlice';
import { useAppDispatch } from 'store/hooks';
import { useGetCountriesQuery, useLazyGetPreparationCentreInfoQuery } from 'store/country/countryAPI';

export const useCountrySelectionFromUri = (handleCountryChange: (countryId?: string) => void) => {
  const dispatch = useAppDispatch();
  const { countryISOUrl, preparationCentreId } = useParams<{ countryISOUrl?: string; preparationCentreId?: string }>();
  const { data: countries, isFetching: isCountryLoading } = useGetCountriesQuery();
  const [
    getPreparationCentreInfo,
    { data: preparationCentreInfo, isLoading: isPreparationCentreLoading, error: preparationCentreError },
  ] = useLazyGetPreparationCentreInfoQuery();

  useEffect(() => {
    if (!countries) {
      return;
    }

    if (preparationCentreId) {
      getPreparationCentreInfo(preparationCentreId);
    }

    if (countryISOUrl) {
      const country = countries.find((x) => x.iso === countryISOUrl);
      handleCountryChange(country?.value);
    }
  }, [countryISOUrl, preparationCentreId, countries, getPreparationCentreInfo, handleCountryChange]);

  useEffect(() => {
    if (preparationCentreInfo) {
      const country = countries?.find((x) => x.value === preparationCentreInfo.countryId.toString());

      if (country) {
        dispatch(setPreparationCentre(preparationCentreInfo));
        handleCountryChange(country.value);
      }
    }
  }, [preparationCentreInfo, countries, dispatch, handleCountryChange]);

  useEffect(() => {
    if (preparationCentreError) {
      toastr.error('Error', 'Registration link appears to be invalid. Please check if you have correct one.');
    }
  }, [preparationCentreError]);

  return isCountryLoading || isPreparationCentreLoading;
};
